"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../../../../providers/CetComponentsProvider");
var _hooks = require("../../../../../hooks");
var useStyles = function useStyles(props) {
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var ccTaskManagerSectionDescriptionStyle = (0, _react.useMemo)(function () {
    var ccTaskManagerSectionDescription = (0, _css.css)({
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText,
      lineHeight: pxToRem(30),
      fontSize: pxToRem(13),
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignContent: 'center',
      alignItems: 'center',
      gap: '0.5rem',
      padding: "0 ".concat(pxToRem(4)),
      flex: 'none',
      span: {
        fontSize: pxToRem(isMobileView ? 16 : 14)
      }
    });
    var ccTaskManagerSectionDescriptionText = (0, _css.css)({});
    return {
      ccTaskManagerSectionDescription: ccTaskManagerSectionDescription,
      ccTaskManagerSectionDescriptionText: ccTaskManagerSectionDescriptionText
    };
  }, [isMobileView, pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText]);
  return {
    'cc-TaskManager__section-description': ccTaskManagerSectionDescriptionStyle.ccTaskManagerSectionDescription,
    'cc-TaskManager__section-description__text': ccTaskManagerSectionDescriptionStyle.ccTaskManagerSectionDescriptionText
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;